import * as React from 'react';

const Logo = () => (
    <div style={{marginRight:'1em'}}>
      <img src={'/logo192.png'} style={{maxWidth: '32px'}} alt={'logo'} />
    </div>
);

export default Logo;
